module.exports = __webpack_public_path__ + "img/xitong_01.1dc5c194.png";